import { FC, useMemo } from 'react'
import { useFormik } from 'formik'
import { useT } from '_metronic/i18n/Metronici18n'
import {
  Button,
  FormDateInput,
  FormSelect,
  FormTimeInput,
  IOption,
  LoadingIndicator,
  useModal,
} from 'app/components'
import { downloadAgendaSchema } from './validation/downloadAgendaSchema'
import { showAlert, showAlertLoading, showError } from '_metronic/helpers/AlertHelper'
import { OptionsHelper } from '_metronic/helpers/OptionsHelpers'
import { ButtonType } from '_metronic/helpers/enumsUI'
import { ExportaSlotsDto } from '../../core/_models'
import { downloadAgenda } from '../../core/_requests'
import { downloadArquivo } from '_metronic/helpers/crud-helper/helpers'

export const DownloadAgendaModal: FC = () => {
  const { closeModal } = useModal()
  const { t } = useT()

  const initialValues = {
    empresa: undefined as IOption<number> | undefined,
    especialidade: undefined as IOption<number> | undefined,
    data: '',
    horarioInicio: '',
    horarioTermino: '',
  }

  const formik = useFormik({
    enableReinitialize: true,
    initialValues,
    validationSchema: useMemo(() => downloadAgendaSchema(t), [t]),
    onSubmit: async (values, { setSubmitting }) => {
      setSubmitting(true)
      try {
        showAlertLoading()

        const data: ExportaSlotsDto = {
          data: values.data,
          horarioInicio: values.horarioInicio,
          horarioTermino: values.horarioTermino,
          idEmpresa: Number(values.empresa?.value),
          idEspecialidade: Number(values.especialidade?.value),
        }
        const arquivo = await downloadAgenda(data)
        downloadArquivo(arquivo)
        await showAlert({
          title: t('common.success'),
          icon: 'success',
        })
        closeModal()
      } catch (error) {
        showError(error)
      } finally {
        setSubmitting(false)
      }
    },
  })

  return (
    <form onSubmit={formik.handleSubmit} noValidate>
      <div className='row'>
        <div className='col-md-6'>
          <FormSelect
            formik={formik}
            name='empresa'
            entity='empresa'
            fetchOptions={OptionsHelper.getOptionsEmpresas}
            isDisabled={formik.isSubmitting}
            className='mb-3'
            isRequired
          />
        </div>
        <div className='col-md-6'>
          <FormSelect
            formik={formik}
            name='especialidade'
            entity='especialidade'
            fetchOptions={OptionsHelper.getOptionsEspecialidades}
            isDisabled={formik.isSubmitting}
            className='mb-3'
            isRequired
          />
        </div>
        <div className='col-md-4'>
          <FormDateInput
            formik={formik}
            name='data'
            entity='data'
            isDisabled={formik.isSubmitting}
            className='mb-3'
            isRequired
          />
        </div>
        <div className='col-md-4'>
          <FormTimeInput
            formik={formik}
            name='horarioInicio'
            entity='horario_inicio'
            isDisabled={formik.isSubmitting}
            className='mb-3'
            isRequired
          />
        </div>
        <div className='col-md-4'>
          <FormTimeInput
            formik={formik}
            name='horarioTermino'
            entity='horario_termino'
            isDisabled={formik.isSubmitting}
            className='mb-3'
            isRequired
          />
        </div>
      </div>

      <div className='d-flex justify-content-center mt-5'>
        <Button type={ButtonType.Reset} onClick={closeModal} className='btn-secondary me-3'>
          {t('common.cancel')}
        </Button>

        <Button type={ButtonType.Submit} className='btn-primary' disabled={formik.isSubmitting}>
          {formik.isSubmitting ? <LoadingIndicator /> : t('common.download')}
        </Button>
      </div>
    </form>
  )
}
